import styled from 'styled-components';

export const BookingConfirmed = styled.div`
  display: flex;
  flex-direction: column;
  background: #D1F8E6;
  border-radius: 0px 0px 16px 16px;
  padding: 16px;
`;

export const HeadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px 16px 0px;
`;

export const GreenTick = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
`;

export const HeadingTxt = styled.h2`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  font-family: 'Rubik';
  text-transform: uppercase;
  color: #0B4F57;
`;

export const FooterTxt = styled.p`
  color: #1A7971;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 16px;
`;